export enum StatusType{ AutomaticInspection = 0, Tiling = 1, Drawing = 2 }
export default class StatusDTO{
    public type: StatusType;
    public done: boolean;
    public text: string;
    public statusCode: number;
}